import React from "react";
import styled from "styled-components";

// import icon from "../../assets/test.svg";
import { devices } from "../../styles";
import pdfIcon from "../../assets/pdf.png";
import altImage from "../../assets/alt-progress.svg";
import altImageComplete from "../../assets/alt-progress-complete.svg";
import altImageWhite from "../../assets/alt-progress-white.svg";
import Step1 from "./ProgressIcons/step-1.svg";
import Step2 from "./ProgressIcons/step-2.svg";
import Step3 from "./ProgressIcons/step-3.svg";
import Step4 from "./ProgressIcons/step-4.svg";
import Step5 from "./ProgressIcons/step-5.svg";
import Step6 from "./ProgressIcons/step-6.svg";
import Step7 from "./ProgressIcons/step-7.svg";
import Step8 from "./ProgressIcons/step-8.svg";
import Step9 from "./ProgressIcons/step-9.svg";
import Step10 from "./ProgressIcons/step-10.svg";



export default function ProgressBar({
  isQuestionnaire = false,
  progress = [],
}) {
	
    const ProgressIcons = {
      1: Step1,
      2: Step2,
      3: Step3,
      4: Step4,
      5: Step5,
      6: Step6,
      7: Step7,
      8: Step8,
      9: Step9,
      10: Step10,
    };

    const progressLabels = {
      0: "Symptoms",
      1: "Leg selection",
      2: "Compression class",
      3: "Please wait...",
      4: "Garment selection",
      5: "Measurements",
      6: "Preferences",
      7: "Product information",
      8: "Product code summary",
      9: "Product code summary",
    };


    let lastTrueIndex = progress.lastIndexOf(true);

    if (lastTrueIndex === progress.length - 1) {
      lastTrueIndex = 9;
    }

    return (
    <Wrapper isQuestionnaire={isQuestionnaire}>
      
      { isQuestionnaire  && (

                <img
                  alt=""
                  style={{ marginLeft: "8px", marginRight: "8px" }}
                  height="24px"
                  width="24px"
                  src={ProgressIcons[lastTrueIndex + 1]}
                />
                
      )}
        {!isQuestionnaire && progress[0] === true && progress[1] === false && progress[2] === false && (
          <img
            alt=""
            style={{ marginLeft: "8px", marginRight: "8px" }}
            height="24px"
            width="24px"
            src={Step3}
          />
        )}
        {!isQuestionnaire && progress[0] === true && progress[1] === true && progress[2] === false && (
          <img
            alt=""
            style={{ marginLeft: "8px", marginRight: "8px" }}
            height="24px"
            width="24px"
            src={Step7}
          />
        )}
        {!isQuestionnaire && progress[0] === true && progress[1] === true && progress[2] === true && (
          <img
            alt=""
            style={{ marginLeft: "8px", marginRight: "8px" }}
            height="24px"
            width="24px"
            src={Step10}
          />
        )}
        {isQuestionnaire && (
          <ProgressLabel>{progressLabels[lastTrueIndex]}</ProgressLabel>
        )}
        {!isQuestionnaire && (
          <ProgressLabel>Onboarding</ProgressLabel>
        )}

        <em></em>
    </Wrapper>
  );
}

export const LeaveAppProgress = () => {
  return (
    <LeaveAppWrapper>
      <DotAlt />
      <LineAlt />
      <DotAlt />
      <LineAlt />
      <DotAlt />
      <LineAlt />
      <img
        alt=""
        style={{ marginLeft: "8px", marginRight: "8px" }}
        height="24px"
        width="24px"
        src={altImageWhite}
      />
      <LineAlt />
      <img
        alt=""
        style={{ marginLeft: "8px" }}
        height="24px"
        width="24px"
        src={pdfIcon}
      />
    </LeaveAppWrapper>
  );
};

const ProgressLabel = styled.span`
  font-weight: bold;
  color: ${(props) => props.theme.colorTertiary};
  font-size:18px;
  line-height: 28px;


  @media ${devices.tablet} {
      font-size:22px;
      line-height: 32px;
    }

  
  
  `;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  max-width: ${(props) => (props.isQuestionnaire ? "877px" : "877px")};

  @media ${devices.tablet} {
    max-width: ${(props) => (props.isQuestionnaire ? "877px" : "877px")};
  }
`;

const LeaveAppWrapper = styled(Wrapper)`
  justify-self: flex-start;
  width: 155px;
  margin-left: 72px;

  @media ${devices.tablet} {
    margin-left: 88px;
    width: 300px;
  }
  @media ${devices.desktop} {
    margin-left: 300px;
  }
`;

const Dot = styled.div`
  height: 9px;
  width: 9px;
  border-radius: 50%;
  background: ${(props) =>
    props.isComplete ? props.theme.colorPrimary : "#D4CCBD"};
  position: relative;

  &:not(:first-child) {
    margin-left: ${(props) => (props.isQuestionnaire ? "8px" : "10px")};
  }
  &:not(:last-child) {
    margin-right: ${(props) => (props.isQuestionnaire ? "8px" : "10px")};
  }

  @media (max-width: 400px) {
    &:not(:first-child) {
      margin-left: ${(props) => (props.isQuestionnaire ? "6px" : "10px")};
    }
    &:not(:last-child) {
      margin-right: ${(props) => (props.isQuestionnaire ? "6px" : "10px")};
    }
  }
`;

const DotAlt = styled(Dot)`
  background: ${(props) => props.theme.colorSecondary};
`;

const Line = styled.div`
  height: 2px;
  background: ${(props) =>
    props.isComplete ? props.theme.colorPrimary : "#D4CCBD"};
  flex: 1;
`;
const LineAlt = styled(Line)`
  background: ${(props) => props.theme.colorSecondary};
`;

const AltDot = styled.img`
  height: 17px;
  width: 17px;
  margin: 0px 8px 0px 8px;

  @media (max-width: 400px) {
    &:not(:first-child) {
      margin-left: 6px;
    }
    &:not(:last-child) {
      margin-right: 6px;
    }
  }
`;
